import {z} from 'zod';

export const TriggerReferenceIdSchema = z
  .string()
  .nullable()
  .transform(value => (value === '' ? null : value));
